import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { Helmet } from 'react-helmet';

function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    setLoading(true);
    setError(null);
    const { data, error } = await supabase.from('blog_posts').select('*').eq('status', 'published').order('published_at', { ascending: false });
    if (error) setError(error);
    else setPosts(data);
    setLoading(false);
  };

  return (
    <div className="blog-list-page">
      <Helmet>
        <title>Blog - darsgah-e-ahlebait</title>
        <meta name="description" content="Read the latest blog posts and articles from darsgah-e-ahlebait." />
      </Helmet>
      <div className="container">
        <h2 className="fw-bold mb-4">Blog</h2>
        <div className="mb-4">
          <Link to="/blog/submit" className="btn btn-success btn-lg fw-bold shadow-sm">
            <i className="bi bi-plus-circle me-2"></i> Add Your Blog
          </Link>
        </div>
        {loading ? <div>Loading...</div> : (
          <>
            {error && <div className="alert alert-danger">Error: {error.message}</div>}
            <div className="row g-4">
              {posts.map(post => (
                <div className="col-md-4" key={post.id}>
                  <div className="card h-100 shadow-sm border-0 rounded-4">
                    {post.cover_image_url && <img src={post.cover_image_url} className="card-img-top rounded-top-4" alt={post.title} style={{maxHeight: '180px', objectFit: 'cover'}} />}
                    <div className="card-body">
                      <h5 className="card-title fw-bold">
                        <Link to={`/blog/${post.slug}`} className="text-decoration-none">{post.title}</Link>
                      </h5>
                      <div className="mb-2 text-secondary" style={{fontSize: '0.98rem'}}>{new Date(post.published_at || post.created_at).toLocaleDateString()}</div>
                      <p className="card-text">{post.summary}</p>
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {post.tags && Array.isArray(post.tags) && post.tags.map((tag, i) => (
                          <span key={i} className="badge bg-info bg-opacity-10 text-info fw-normal">{tag}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default BlogList; 